document.addEventListener('DOMContentLoaded', function () {

    const music = document.getElementById('bg-music');
    const button = document.getElementById('music-control');
    const icon = document.getElementById('music-icon');
    const hero = document.getElementById('hero');

    let musicStarted = false;
    let userInteracted = false;

    function updateIcon(isPlaying) {
        if (isPlaying) {
            icon.classList.remove('bi-play-fill');
            icon.classList.add('bi-pause-fill');
        } else {
            icon.classList.remove('bi-pause-fill');
            icon.classList.add('bi-play-fill');
        }
    }

    function playMusic() {
        music.play()
            .then(() => {
                musicStarted = true;
                updateIcon(true);
            })
            .catch(() => {
                // Se autoplay for bloqueado no mobile,
                // aguardamos a primeira interação
                console.log("Autoplay bloqueado, aguardando interação...");
            });
    }

    // 🎯 1️⃣ Tocar ao sair do hero (desktop funciona direto)
    window.addEventListener('scroll', function () {

        if (!musicStarted) {

            const heroBottom = hero.getBoundingClientRect().bottom;

            if (heroBottom <= 0) {
                playMusic();
            }
        }
    });

    // 📱 2️⃣ Primeira interação no mobile libera autoplay
    function enableOnFirstInteraction() {
        if (!userInteracted && !musicStarted) {
            userInteracted = true;
            playMusic();
        }

        document.removeEventListener('touchstart', enableOnFirstInteraction);
        document.removeEventListener('click', enableOnFirstInteraction);
    }

    document.addEventListener('touchstart', enableOnFirstInteraction, { passive: true });
    document.addEventListener('click', enableOnFirstInteraction);

    // 🎵 3️⃣ Botão manual
    button.addEventListener('click', function () {

        if (music.paused) {
            music.play().then(() => {
                updateIcon(true);
            });
        } else {
            music.pause();
            updateIcon(false);
        }

    });

});
